// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"112":"book","387":"online","449":"course","537":"employ","791":"video","845":"profile","953":"courses","962":"present"}[chunkId] + "." + {"112":"912837a0","387":"753f0a6d","449":"1794ffcb","537":"72574d48","791":"fed00f9f","845":"08eacc56","953":"b3564d3a","962":"2da97cc8"}[chunkId] + ".css";
};